module.exports = __webpack_public_path__ + "static/media/gn.1ffeb1c0.svg";